import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import Icon from 'sharedComponents/Icon';
import { Box, Link, Typography, Badge, Menu, MenuItem } from '@material-ui/core';

import UserPresenter from 'presenters/UserPresenter';
import AvatarWithBadge from 'sharedComponents/AvatarWithBadge';

import { appRoutes } from 'routes';
import useStyles from './useStyles';

const MESSAGE_ITEM_NAME = 'messages';

const DesktopMenu = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const [menuLabelElement, setMenuLabelElement] = useState(null);
  const { currentUser, isOnline, menuItems, unreadCount, logout } = props;

  const isBuyer = UserPresenter.isBuyer(currentUser);
  const userType = isBuyer ? t('layouts.AppLayout.anonymous') : UserPresenter.getUserType(currentUser);
  const shouldShowSettingsLink =
    UserPresenter.isBuyer(currentUser) ||
    UserPresenter.isLoanOfficer(currentUser) ||
    UserPresenter.isRealEstateAgent(currentUser);

  const handleMenuOpen = ({ currentTarget }) => setMenuLabelElement(currentTarget);
  const handleMenuClose = () => setMenuLabelElement(null);

  const settingsPath = appRoutes.settingsPath();

  return (
    <div className={classes.root}>
      <Link to={appRoutes.rootPath} component={RouterLink}>
        <Icon name="logo" width="100" />
      </Link>
      <div className={classes.menuItems}>
        {menuItems.map(({ label, name, path, isActive }) => {
          const isMessageItem = name === MESSAGE_ITEM_NAME;
          if (isMessageItem) {
            return (
              <Link
                key={name}
                to={path}
                component={RouterLink}
                className={clsx(classes.menuItem, { [classes.menuItemActive]: isActive })}
              >
                <Badge key={name} color="secondary" badgeContent={unreadCount}>
                  <Typography variant="h2">{t(label)}</Typography>
                </Badge>
              </Link>
            );
          }
          return (
            <Link
              key={name}
              to={path}
              component={RouterLink}
              className={clsx(classes.menuItem, { [classes.menuItemActive]: isActive })}
            >
              <Typography variant="h2">{t(label)}</Typography>
            </Link>
          );
        })}
      </div>
      <div className={classes.userBar}>
        <AvatarWithBadge
          isOnline={isOnline}
          imageUrl={UserPresenter.profileImageUrl(currentUser)}
          label={UserPresenter.initials(currentUser)}
        />
        <Box aria-controls="menu" aria-haspopup="true" className={classes.userLabel} onClick={handleMenuOpen}>
          <Typography variant="h2" className={classes.displayName}>
            {UserPresenter.fullName(currentUser)}
          </Typography>
          <Typography variant="subtitle1" color="secondary">
            {userType}
          </Typography>
        </Box>
        <Menu
          id="menu"
          anchorEl={menuLabelElement}
          keepMounted
          open={Boolean(menuLabelElement)}
          onClose={handleMenuClose}
        >
          {shouldShowSettingsLink && (
            <MenuItem
              className={classes.popupMenuItem}
              onClick={() => {
                history.push(settingsPath);
                handleMenuClose();
              }}
            >
              {t('layouts.AppLayout.Menu.settings')}
            </MenuItem>
          )}
          <MenuItem className={classes.popupMenuItem} onClick={logout}>
            {t('layouts.AppLayout.Menu.logout')}
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
};

DesktopMenu.propTypes = {
  menuItems: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  isOnline: PropTypes.bool.isRequired,
  currentUser: UserPresenter.shape().isRequired,
  unreadCount: PropTypes.number.isRequired,
  logout: PropTypes.func.isRequired,
};

export default DesktopMenu;



// WEBPACK FOOTER //
// ./src/layouts/AppLayout/components/Menu/components/DesktopMenu/DesktopMenu.js